<template>
  <div class="progress-steps">
    <ProgressBarSteps :value="value" :targetSteps="targetSteps" />
  </div>
</template>

<script>
import ProgressBarSteps from '@/components/ProgressBarCircle/ProgressBarSteps.vue';

export default {
  name: 'IndexSteps',
  components: {
    ProgressBarSteps,
  },
  props: {
    value: Number,
    targetSteps: Number,
    simple: Boolean,
    dates: String,
  },
};
</script>

<style lang="scss" scoped>
  .progress-steps {
    display: flex;
  }
</style>
